function calculateMediaContentSize(questionObject, questionType) {

    // Obtencion de las medidas de los componentes superiores e inferiores de la pantalla necesarios para los calculos.
    let screenHeight = $(window).height();
    let headerHeight = $('.play-wrapper.play-header-info-wrapper').height();
    let playSectionHeight = $('.play-info').height();
    let mediaArrowHeight = $('.media-arrow.text-center').height();
    let questionContainerWidth = $('#questionContainer').width();
    let questionTextContainerHeight = $('.question-color-wrapper').height();
    let playBottomHeight = $('#playBottom').height();

    // Contenedor donde se coloca el objeto media.
    const mediaContainer = $('.media-content');

    // Dimensiones originales del objeto media.
    const originalVideoWidth = questionType === "video" ? questionObject.videoWidth : questionObject.naturalWidth;
    const originalVideoHeight = questionType === "video" ? questionObject.videoHeight : questionObject.naturalHeight;

    // Obtencion de la altura del panel inferior de juego dependiendo del tipo de juego (Assessment o Contest).
    const contestBottomBarHeight = playBottomHeight === null ? 0 : playBottomHeight;

    // Espacio vertical extra que ha de tener la ventana para poder mostrar el objeto media con su maxima anchura disponible.
    // IMPORTANTE: Los valores estan ajustados lo maximo posible y no deben modificarse.
    const extraNecessaryHeight = contestBottomBarHeight > 0 ? 250 : 165;

    // Regla de tres para obtener la altura necesaria del objeto media segun el ancho disponible del contenedor.
    let necessaryHeight = originalVideoHeight * questionContainerWidth / originalVideoWidth;

    // Altura a partir de la cual el objeto media empezara a reescalar.
    // IMPORTANTE: Si se quiere mostrar el objeto media mas pequenyo y parte de las preguntas o viceversa modificar el valor de esta variable.
    // IMPORTANTE: Valor 0: la imagen reescala cuando la altura de la ventana toca el contenedor con la flecha para mostrar y ocultar el objeto media.
    let minimumExtraSpaceToResize = screenHeight > 500 ? questionTextContainerHeight : 0;

    let freeSpace = screenHeight - headerHeight - playSectionHeight - mediaArrowHeight - contestBottomBarHeight;

    if (screenHeight >= necessaryHeight + extraNecessaryHeight + minimumExtraSpaceToResize) {
        mediaContainer.css('height', necessaryHeight + 'px');
    } else {
        mediaContainer.css('height', freeSpace - minimumExtraSpaceToResize + 'px');
    }

    $(window).resize(function() {

        screenHeight = $(window).height();
        headerHeight = $('.play-wrapper.play-header-info-wrapper').height();
        playSectionHeight = $('.play-info').height();
        mediaArrowHeight = $('.media-arrow.text-center').height();
        questionContainerWidth = $('#questionContainer').width();
        questionTextContainerHeight = $('.question-color-wrapper').height();

        necessaryHeight = originalVideoHeight * questionContainerWidth / originalVideoWidth;

        minimumExtraSpaceToResize = screenHeight > 500 ? questionTextContainerHeight : 0;

        freeSpace = screenHeight - headerHeight - playSectionHeight - mediaArrowHeight - contestBottomBarHeight;

        if (screenHeight >= necessaryHeight + extraNecessaryHeight + minimumExtraSpaceToResize) {
            mediaContainer.css('height', necessaryHeight + 'px');
        } else {
            mediaContainer.css('height', freeSpace - minimumExtraSpaceToResize + 'px');
        }

    });

}